'use strict';

exports.__esModule = true;
exports.default = ArgumentError;
function ArgumentError(message) {
  this.name = 'ArgumentError';
  this.message = message;
}

ArgumentError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/ArgumentError.js
// module id = 8Zf8
// module chunks = 0